var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0621 1.53451C10.3843 0.663889 11.6157 0.663888 11.9379 1.53451L14.0815 7.32767C14.1828 7.60139 14.3986 7.8172 14.6723 7.91848L20.4655 10.0621C21.3361 10.3843 21.3361 11.6157 20.4655 11.9379L14.6723 14.0815C14.3986 14.1828 14.1828 14.3986 14.0815 14.6723L11.9379 20.4655C11.6157 21.3361 10.3843 21.3361 10.0621 20.4655L7.91848 14.6723C7.8172 14.3986 7.60139 14.1828 7.32767 14.0815L1.53451 11.9379C0.663889 11.6157 0.663888 10.3843 1.53451 10.0621L7.32767 7.91848C7.60139 7.8172 7.8172 7.60139 7.91848 7.32767L10.0621 1.53451Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarWhite);
export default __webpack_public_path__ + "static/media/starWhite.4b50a1cc23b26241eb24f7fd3d2acdc5.svg";
export { ForwardRef as ReactComponent };